<template>
  <div class="chinese_container">
    <myHeader />

    <div class="bg">
      <div class="headbanner">
        <h1 class="wow fadeInUp">hecoos Studio离线版</h1>
        <p class="wow fadeInUp">
          若您需要进一步了解相关信息 ，请随时联系我们，我们将竭诚为您解答。
        </p>

        <div>
          <router-link
            :to="{ name: 'chCaseDemonstration', hash: '#specific-position' }"
            class="setting_a2"
          >
            <button class="consult-button wow fadeInUp">立即咨询</button>
          </router-link>
        </div>
      </div>
      <div ref="holder" class="waves"></div>
    </div>

    <div class="bg1">
      <div>
        <h1 class="headtext wow fadeInUp">独立加密锁，离线亦可工作</h1>
      </div>

      <div class="slider wow fadeInUp">
        <div
          class="slider-wrapper"
          :style="{
            transform: `translateX(-${(currentIndex * 150) / slides.length}%)`,
          }"
        >
          <div
            v-for="(slide, index) in slides"
            :key="index"
            class="slide"
            :class="{ hiddenImg: currentIndex == 0 && index == 3 }"
          >
            <img :src="slide.image" alt="slide" />
            <p>{{ slide.desc }}</p>
          </div>
        </div>
      </div>
      <div class="parents">
        <button
          class="arrow-button"
          @click="prevSlide"
          :class="{ disableBtn: currentIndex == 0 }"
        >
          <i class="el-icon-arrow-left"></i>
        </button>
        <button
          class="arrow-button"
          @click="nextSlide"
          :class="{ disableBtn: currentIndex == slides.length - 2 }"
        >
          <i class="el-icon-arrow-right"></i>
        </button>
      </div>
    </div>

    <myFooter />
    <BackToTop />
  </div>
</template>

<script>
import BackToTop from "@/components/pc/BackToTop";
import myHeader from "@/components/pc/myHeader";
import myFooter from "@/components/pc/myFooter";

export default {
  components: { myHeader, myFooter, BackToTop },
  data() {
    return {
      currentIndex: 0,
      slides: [
        {
          image:"https://download.hecoos.com/enlightv/2025-37/28b0215286c7d1e1c1907b0a918d8b81.png",
          desc: "三维场景预演、投影仿真、灯光效果编辑与导播设计",
        },
        {
          image:"https://download.hecoos.com/enlightv/2025-37/5b9aa1b57aec71f2b1b8d35047e0ce57.png",
          desc: "2*2K测试信号输出(带水印) 外部设备控制(间歇性中断)",
        },
        {
          image:
            "https://download.hecoos.com/enlightv/2025-17/9c609c133d5ff2e733e08934ef8167c5.png",
          desc: "节目与控制指令编辑 项目现场调试",
        },
        {
          image:
            "https://download.hecoos.com/enlightv/2025-35/02a5e47e63883b0428b059fb2ae7357b.jpg",
          desc: "作为项目测试端应用可脱离hecoos服务器使用",
        },
      ],
      shaderInstance: null,
    };
  },
  mounted() {
    // this.shaderInstance = createWaveShader(this.$refs.holder, {
    //   onResize: (w, h, dpi) => {
    //     // 可以在这里添加额外的调整逻辑
    //     console.log('Wave resized:', w, h, dpi);
    //   },
    //   onUpdate: (delta) => {
    //     // 每帧更新的回调
    //   }
    // });
    this.$nextTick(() => {
      this.getCanvas();
    });
  },
  methods: {
    prevSlide() {
      if (this.currentIndex != 0) {
        this.currentIndex =
          (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      }
    },
    nextSlide() {
      if (this.currentIndex != this.slides.length - 2) {
        this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      }
    },

    getCanvas() {
      class ShaderProgram {
        constructor(holder, options = {}) {
          options = Object.assign(
            {
              antialias: false,
              depthTest: false,
              mousemove: false,
              autosize: true,
              side: "front",
              vertex: `
        precision highp float;

        attribute vec4 a_position;
        attribute vec4 a_color;

        uniform float u_time;
        uniform vec2 u_resolution;
        uniform vec2 u_mousemove;
        uniform mat4 u_projection;

        varying vec4 v_color;

        void main() {

          gl_Position = u_projection * a_position;
          gl_PointSize = (10.0 / gl_Position.w) * 100.0;

          v_color = a_color;

        }`,
              fragment: `
        precision highp float;

        uniform sampler2D u_texture;
        uniform int u_hasTexture;

        varying vec4 v_color;

        void main() {

          if ( u_hasTexture == 1 ) {

            gl_FragColor = v_color * texture2D(u_texture, gl_PointCoord);

          } else {

            gl_FragColor = v_color;

          }

        }`,
              uniforms: {},
              buffers: {},
              camera: {},
              texture: null,
              onUpdate: () => {},
              onResize: () => {},
            },
            options
          );

          const uniforms = Object.assign(
            {
              time: { type: "float", value: 0 },
              hasTexture: { type: "int", value: 0 },
              resolution: { type: "vec2", value: [0, 0] },
              mousemove: { type: "vec2", value: [0, 0] },
              projection: {
                type: "mat4",
                value: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
              },
            },
            options.uniforms
          );

          const buffers = Object.assign(
            {
              position: { size: 3, data: [] },
              color: { size: 4, data: [] },
            },
            options.buffers
          );

          const camera = Object.assign(
            {
              fov: 60,
              near: 1,
              far: 10000,
              aspect: 1,
              z: 100,
              perspective: true,
            },
            options.camera
          );

          const canvas = document.createElement("canvas");
          const gl = canvas.getContext("webgl", {
            antialias: options.antialias,
          });

          if (!gl) return false;

          this.count = 0;
          this.gl = gl;
          this.canvas = canvas;
          this.camera = camera;
          this.holder = holder;
          this.onUpdate = options.onUpdate;
          this.onResize = options.onResize;
          this.data = {};

          holder.appendChild(canvas);

          this.createProgram(options.vertex, options.fragment);

          this.createBuffers(buffers);
          this.createUniforms(uniforms);

          this.updateBuffers();
          this.updateUniforms();

          this.createTexture(options.texture);

          gl.enable(gl.BLEND);
          gl.enable(gl.CULL_FACE);
          gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
          gl[options.depthTest ? "enable" : "disable"](gl.DEPTH_TEST);

          if (options.autosize)
            window.addEventListener("resize", (e) => this.resize(e), false);
          if (options.mousemove)
            window.addEventListener(
              "mousemove",
              (e) => this.mousemove(e),
              false
            );

          this.resize();

          this.update = this.update.bind(this);
          this.time = { start: performance.now(), old: performance.now() };
          this.update();
        }

        mousemove(e) {
          let x = (e.pageX / this.width) * 2 - 1;
          let y = (e.pageY / this.height) * 2 - 1;

          this.uniforms.mousemove = [x, y];
        }

        resize(e) {
          const holder = this.holder;
          const canvas = this.canvas;
          const gl = this.gl;

          const width = (this.width = holder.offsetWidth);
          const height = (this.height = holder.offsetHeight);
          const aspect = (this.aspect = width / height);
          const dpi = devicePixelRatio;

          canvas.width = width * dpi;
          canvas.height = height * dpi;
          canvas.style.width = width + "px";
          canvas.style.height = height + "px";

          gl.viewport(0, 0, width * dpi, height * dpi);
          gl.clearColor(0, 0, 0, 0);

          this.uniforms.resolution = [width, height];
          this.uniforms.projection = this.setProjection(aspect);

          this.onResize(width, height, dpi);
        }

        setProjection(aspect) {
          const camera = this.camera;

          if (camera.perspective) {
            camera.aspect = aspect;

            const fovRad = camera.fov * (Math.PI / 180);
            const f = Math.tan(Math.PI * 0.5 - 0.5 * fovRad);
            const rangeInv = 1.0 / (camera.near - camera.far);

            const matrix = [
              f / camera.aspect,
              0,
              0,
              0,
              0,
              f,
              0,
              0,
              0,
              0,
              (camera.near + camera.far) * rangeInv,
              -1,
              0,
              0,
              camera.near * camera.far * rangeInv * 2,
              0,
            ];

            matrix[14] += camera.z;
            matrix[15] += camera.z;

            return matrix;
          } else {
            return [
              2 / this.width,
              0,
              0,
              0,
              0,
              -2 / this.height,
              0,
              0,
              0,
              0,
              1,
              0,
              -1,
              1,
              0,
              1,
            ];
          }
        }

        createShader(type, source) {
          const gl = this.gl;
          const shader = gl.createShader(type);

          gl.shaderSource(shader, source);
          gl.compileShader(shader);

          if (gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
            return shader;
          } else {
            console.log(gl.getShaderInfoLog(shader));
            gl.deleteShader(shader);
          }
        }

        createProgram(vertex, fragment) {
          const gl = this.gl;

          const vertexShader = this.createShader(gl.VERTEX_SHADER, vertex);
          const fragmentShader = this.createShader(
            gl.FRAGMENT_SHADER,
            fragment
          );

          const program = gl.createProgram();

          gl.attachShader(program, vertexShader);
          gl.attachShader(program, fragmentShader);
          gl.linkProgram(program);

          if (gl.getProgramParameter(program, gl.LINK_STATUS)) {
            gl.useProgram(program);
            this.program = program;
          } else {
            console.log(gl.getProgramInfoLog(program));
            gl.deleteProgram(program);
          }
        }

        createUniforms(data) {
          const gl = this.gl;
          const uniforms = (this.data.uniforms = data);
          const values = (this.uniforms = {});

          Object.keys(uniforms).forEach((name) => {
            const uniform = uniforms[name];

            uniform.location = gl.getUniformLocation(this.program, "u_" + name);

            Object.defineProperty(values, name, {
              set: (value) => {
                uniforms[name].value = value;
                this.setUniform(name, value);
              },
              get: () => uniforms[name].value,
            });
          });
        }

        setUniform(name, value) {
          const gl = this.gl;
          const uniform = this.data.uniforms[name];

          uniform.value = value;

          switch (uniform.type) {
            case "int": {
              gl.uniform1i(uniform.location, value);
              break;
            }
            case "float": {
              gl.uniform1f(uniform.location, value);
              break;
            }
            case "vec2": {
              gl.uniform2f(uniform.location, ...value);
              break;
            }
            case "vec3": {
              gl.uniform3f(uniform.location, ...value);
              break;
            }
            case "vec4": {
              gl.uniform4f(uniform.location, ...value);
              break;
            }
            case "mat2": {
              gl.uniformMatrix2fv(uniform.location, false, value);
              break;
            }
            case "mat3": {
              gl.uniformMatrix3fv(uniform.location, false, value);
              break;
            }
            case "mat4": {
              gl.uniformMatrix4fv(uniform.location, false, value);
              break;
            }
          }

          // ivec2       : uniform2i,
          // ivec3       : uniform3i,
          // ivec4       : uniform4i,
          // sampler2D   : uniform1i,
          // samplerCube : uniform1i,
          // bool        : uniform1i,
          // bvec2       : uniform2i,
          // bvec3       : uniform3i,
          // bvec4       : uniform4i,
        }

        updateUniforms() {
          const gl = this.gl;
          const uniforms = this.data.uniforms;

          Object.keys(uniforms).forEach((name) => {
            const uniform = uniforms[name];

            this.uniforms[name] = uniform.value;
          });
        }

        createBuffers(data) {
          const gl = this.gl;
          const buffers = (this.data.buffers = data);
          const values = (this.buffers = {});

          Object.keys(buffers).forEach((name) => {
            const buffer = buffers[name];

            buffer.buffer = this.createBuffer("a_" + name, buffer.size);

            Object.defineProperty(values, name, {
              set: (data) => {
                buffers[name].data = data;
                this.setBuffer(name, data);

                if (name == "position")
                  this.count = buffers.position.data.length / 3;
              },
              get: () => buffers[name].data,
            });
          });
        }

        createBuffer(name, size) {
          const gl = this.gl;
          const program = this.program;

          const index = gl.getAttribLocation(program, name);
          const buffer = gl.createBuffer();

          gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
          gl.enableVertexAttribArray(index);
          gl.vertexAttribPointer(index, size, gl.FLOAT, false, 0, 0);

          return buffer;
        }

        setBuffer(name, data) {
          const gl = this.gl;
          const buffers = this.data.buffers;

          if (name == null && !gl.bindBuffer(gl.ARRAY_BUFFER, null)) return;

          gl.bindBuffer(gl.ARRAY_BUFFER, buffers[name].buffer);
          gl.bufferData(
            gl.ARRAY_BUFFER,
            new Float32Array(data),
            gl.STATIC_DRAW
          );
        }

        updateBuffers() {
          const gl = this.gl;
          const buffers = this.buffers;

          Object.keys(buffers).forEach((name) => (buffers[name] = buffer.data));

          this.setBuffer(null);
        }

        createTexture(src) {
          const gl = this.gl;
          const texture = gl.createTexture();

          gl.bindTexture(gl.TEXTURE_2D, texture);
          gl.texImage2D(
            gl.TEXTURE_2D,
            0,
            gl.RGBA,
            1,
            1,
            0,
            gl.RGBA,
            gl.UNSIGNED_BYTE,
            new Uint8Array([0, 0, 0, 0])
          );

          this.texture = texture;

          if (src) {
            this.uniforms.hasTexture = 1;
            this.loadTexture(src);
          }
        }

        loadTexture(src) {
          const gl = this.gl;
          const texture = this.texture;

          const textureImage = new Image();

          textureImage.onload = () => {
            gl.bindTexture(gl.TEXTURE_2D, texture);

            gl.texImage2D(
              gl.TEXTURE_2D,
              0,
              gl.RGBA,
              gl.RGBA,
              gl.UNSIGNED_BYTE,
              textureImage
            );

            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

            gl.texParameteri(
              gl.TEXTURE_2D,
              gl.TEXTURE_WRAP_S,
              gl.CLAMP_TO_EDGE
            );
            gl.texParameteri(
              gl.TEXTURE_2D,
              gl.TEXTURE_WRAP_T,
              gl.CLAMP_TO_EDGE
            );
          };

          textureImage.src = src;
        }

        update() {
          const gl = this.gl;

          const now = performance.now();
          const elapsed = (now - this.time.start) / 5000;
          const delta = now - this.time.old;
          this.time.old = now;

          this.uniforms.time = elapsed;

          if (this.count > 0) {
            gl.clear(gl.COLORBUFFERBIT);
            gl.drawArrays(gl.POINTS, 0, this.count);
          }

          this.onUpdate(delta);

          requestAnimationFrame(this.update);
        }
      }
      const pointSize = 2.5;
      const waves = new ShaderProgram(document.querySelector(".waves"), {
        texture:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAb1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8v0wLRAAAAJHRSTlMAC/goGvDhmwcExrVjWzrm29TRqqSKenRXVklANSIUE8mRkGpv+HOfAAABCElEQVQ4y4VT13LDMAwLrUHteO+R9f/fWMfO6dLaPeKVEECRxOULWsEGpS9nULDwia2Y+ALqUNbAWeg775zv+sA4/FFRMxt8U2FZFCVWjR/YrH4/H9sarclSKdPMWKzb8VsEeHB3m0shkhVCyNzeXeAQ9Xl4opEieX2QCGnwGbj6GMyjw9t1K0fK9YZunPXeAGsfJtYjwzxaBnozGGorYz0ypK2HzQSYx1y8DgSRo2ewOiyh2QWOEk1Y9OrQV0a8TiBM1a8eMHWYnRMy7CZ4t1CmyRkhSUvP3gRXyHOCLBxNoC3IJv//ZrJ/kxxUHPUB+6jJZZHrpg6GOjnqaOmzp4NDR48OLxn/H27SRQ08S0ZJAAAAAElFTkSuQmCC",
        uniforms: {
          size: { type: "float", value: pointSize },
          field: { type: "vec3", value: [0, 0, 0] },
          speed: { type: "float", value: 5 },
        },
        vertex: `
    #define M_PI 3.1415926535897932384626433832795

    precision highp float;

    attribute vec4 a_position;
    attribute vec4 a_color;

    uniform float u_time;
    uniform float u_size;
    uniform float u_speed;
    uniform vec3 u_field;
    uniform mat4 u_projection;

    varying vec4 v_color;

    void main() {

      vec3 pos = a_position.xyz;

      pos.y += (
        cos(pos.x / u_field.x * M_PI * 8.0 + u_time * u_speed) +
        sin(pos.z / u_field.z * M_PI * 8.0 + u_time * u_speed)
      ) * u_field.y;

      gl_Position = u_projection * vec4( pos.xyz, a_position.w );
      gl_PointSize = ( u_size / gl_Position.w ) * 100.0;

      v_color = a_color;

    }`,
        fragment: `
    precision highp float;

    uniform sampler2D u_texture;

    varying vec4 v_color;

    void main() {

      gl_FragColor = v_color * texture2D(u_texture, gl_PointCoord);

    }`,
        onResize(w, h, dpi) {
          const position = [],
            color = [];

          const width = 400 * (w / h);
          const depth = 400;
          const height = 3;
          const distance = 5;

          for (let x = 0; x < width; x += distance) {
            for (let z = 0; z < depth; z += distance) {
              position.push(-width / 2 + x, -30, -depth / 2 + z);
              color.push(
                0,
                1 - (x / width) * 1,
                0.5 + (x / width) * 0.5,
                z / depth
              );
            }
          }

          this.uniforms.field = [width, height, depth];

          this.buffers.position = position;
          this.buffers.color = color;

          this.uniforms.size = (h / 400) * pointSize * dpi;
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/optimize_adaptation.scss";
</style>
<style scoped>
.consult-button {
  height: 50px;
  width: 151px;
  font-size: 20px;
  border-radius: 28px;
  background-color: #147cf5;
  margin-top: 30px;
  color: white;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-size: 20px;
  font-weight: 500;
  /* border: 1px solid red; */
  transition: all 0.5s ease;
}
.consult-button:hover {
  background-color: white;
  color: #147cf5;
  transform: scale(1.05);
}

.bg {
  /*background-image: url("https://download.hecoos.com/enlightv/2025-17/3491cedaea8c7d7c870a7f1a06d77256.png");*/
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: black;
  position: relative;
  height: calc(100vh - 152px);
}
.bg .waves {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
}

.bg1 {
  background-color: black;
  padding: 200px 0;
  overflow: hidden;
}
.headbanner h1 {
  font-size: 72px;
  text-align: center;
  color: white;
}
.headbanner p {
  font-size: 36px;
  text-align: center;
  color: white;
  line-height: 60px;
  /* font-family: YourFontName4; */
  font-family: "思源黑体Medium" !important;
}
.headbanner {
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 11;
}

.slider-wrapper {
  display: flex;
  transition: transform 1s ease;
  justify-content: flex-start;
}

.slide {
  padding: 0px 10px;
}

.slide p {
  color: white;
  padding: 30px;
  font-size: 18px;
  /* font-family: YourFontName2; */
}

.slider {
  width: 60%;
  margin: 0 auto;
  /* text-align: center; */
}
.headtext {
  padding: 0 0 100px 0;
  background: linear-gradient(
    to left,
    rgba(76, 142, 212, 1),
    rgba(128, 99, 220, 1),
    rgba(173, 63, 226, 1)
  ); /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
  background-clip: text; /*将设置的背景颜色限制在文字中*/
  -webkit-text-fill-color: transparent; /*给文字设置成透明*/
  font-size: 72px;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 95px;
  text-align: center;
  vertical-align: top;
  font-family: YourFontName3;
}
.colorb {
  color: #6600ff;
}
.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 30px;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 10px 15px;

  border-radius: 50%;
}

.arrow-button {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background-color: #343334;
  color: white;
  font-size: 20px;
  cursor: pointer;
  margin-right: 20px;
  transition: all 0.5s ease;
}

.arrow-button:hover {
  background-color: rgba(255, 255, 255, 0.4);
  transform: scale(1.05);
}

.parents {
  text-align: right;
  height: 50px;
  padding-right: 100px;
}

.prev {
  left: 10px;
}

.next {
  right: 10px;
}
.disableBtn {
  opacity: 0.4;
  cursor: default !important;
}
.hiddenImg {
  opacity: 0;
}
.my_software .disableBtn:hover {
  background-color: #343334;
}
</style>
